<div id="product-description-classification-wrapper">
  <div
    [class.hide-unique]="!showUniqueSelling"
    [class.hide-desc]="!showProdDesc"
    class="container"
    id="product-description-classification"
    [ngClass]="activeLanguage$ | async"
  >
    <div id="product-left">
      <ng-container *ngIf="showUniqueSelling">
        <h2>{{ 'product.productOptions.uniqueSellingPoints.title' | cxTranslate }}</h2>
        <section [innerHTML]="clasificationResult"></section>
      </ng-container>
    </div>
    <div id="product-right">
      <ng-container *ngIf="showProdDesc">
        <div id="product-right-inner-wrapper">
          <h2>{{ 'product.productOptions.productDescription.title' | cxTranslate }}</h2>
          <div>
            <span [innerHTML]="descriptionResult?.message"></span>&nbsp;
            <a class="read-more-less" *ngIf="descriptionResult?.showButton" (click)="loadDescriptionisClicked()">
              {{ descriptionResult.showButtonMessage }}
            </a>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-container *ngIf="logisticsTrigger && logisticInfo$ | async as logist">
  <ng-container *ngIf="hasLogisticInfo(logist)">
    <mat-expansion-panel class="product-descr-panel">
      <mat-expansion-panel-header class="pdp-logist-panel-header">
        <mat-panel-title #matPanelClick class="pdp-logist-label">
          {{ 'fish.logisticInfo.title' | cxTranslate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-container class="logisticDescr">
        <div *ngIf="logist?.logisticWeightNettGram" class="feature-wrapper">
          <div>{{ 'fish.logisticInfoLabels.weightNettgram' | cxTranslate }}</div>
          <div>{{ logist?.logisticWeightNettGram }}</div>
        </div>
        <div *ngIf="logist?.logisticWeightGrossGram" class="feature-wrapper">
          <div>{{ 'fish.logisticInfoLabels.LogisticWeightGrossgram' | cxTranslate }}</div>
          <div>{{ logist?.logisticWeightGrossGram }}</div>
        </div>
        <div *ngIf="logist?.logisticDimensionLength" class="feature-wrapper">
          <div>{{ 'fish.logisticInfoLabels.LogisticDimensionLength' | cxTranslate }}</div>
          <div>{{ logist?.logisticDimensionLength }}</div>
        </div>
        <div *ngIf="logist?.logisticHeight" class="feature-wrapper">
          <div>{{ 'fish.logisticInfoLabels.height' | cxTranslate }}</div>
          <div>{{ logist?.logisticHeight }}</div>
        </div>
        <div *ngIf="logist?.logisticWidth" class="feature-wrapper">
          <div>{{ 'fish.logisticInfoLabels.Width' | cxTranslate }}</div>
          <div>{{ logist?.logisticWidth }}</div>
        </div>
      </ng-container>
    </mat-expansion-panel>
  </ng-container>
</ng-container>

<ng-container *ngIf="specifications$ | async as specs">
  <ng-container *ngIf="specs.classifications as spec">
    <mat-expansion-panel
      class="product-descr-panel"
      [class.removeBorderTop]="logisticsTrigger && hasLogistInfo"
      [ngClass]="activeLanguage$ | async"
    >
      <mat-expansion-panel-header class="pdp-specs-panel-header">
        <mat-panel-title #matPanelClick class="pdp-specs-label">
          {{ 'product.productOptions.productSpecification.title' | cxTranslate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-container *ngFor="let item of spec">
        <ng-container *ngFor="let data of item.features">
          <div class="feature-wrapper">
            <div>{{ data?.name }}</div>
            <div [innerHTML]="(data?.featureValues)[0].value"></div>
          </div>
        </ng-container>
      </ng-container>
    </mat-expansion-panel>
  </ng-container>
</ng-container>
